<template>
    <div class="msg-wrap">
        <div class="menu-wrap">
            <el-form :inline="true" >
                <el-form-item label="开始时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="start_date"
                    type="date"
                    class="start_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="start_time"
                    class="start_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>
        
                <el-form-item label="结束时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="end_date"
                    type="date"
                    class="end_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="end_time"
                    class="end_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>

                <el-form-item label="选择预设时间">
                    <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                    <el-option label="自定义" value="customize"></el-option>
                    <el-option label="最近一天" value="day"></el-option>
                    <el-option label="最近一周" value="week"></el-option>
                    <el-option label="最近一月" value="month"></el-option>
                    <el-option label="最近一年" value="year"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-button plain type="primary" class="menu-btn" @click="searchData()">
                    查询
                </el-button>

                <!--数据导出-->
                <download-excel 
                    class = "export-excel-wrapper"
                    :data = "msglist"
                    :fields = "msgFileds"
                    :header="msgHeader"
                    :before-generate="exportFile"
                    :name = "msgFileName">
                    <el-button plain type="primary" class="menu-btn">
                        导出
                    </el-button>
                </download-excel>

                <el-button plain type="primary" class="menu-btn" @click="showNoticeDialog">
                    通知
                </el-button>

            </el-form>
        </div>

        <!--消息通知记录-->
        <div class="record">
             <el-table
                :data="msglist"
                border
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                :max-height="tableHeight"
                class="record-table"
                style="width: 100%">
                <el-table-column
                    width="250px"
                    prop="templatetitle"
                    label="模板类型">
                </el-table-column>

                <el-table-column
                    width="250px"
                    prop="tousername"
                    label="接收人">
                </el-table-column>

                <el-table-column
                    width="250px"
                    label="接收人单位">
                     <template slot-scope="scope">
                        <span v-if="userList&&userList[scope.row.touserwx]">{{userList[scope.row.touserwx].UserCompany}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="status"
                    label="接收状态">
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    width="110"
                    label="发送时间">
                </el-table-column>
                <el-table-column
                    prop="fromusername"
                    label="发送人">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleLook(scope.$index, scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <el-pagination
                v-if="msgpage.total>0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="msgpage.current"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="msgpage.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="msgpage.total"
                class="pagination">
            </el-pagination>
        </div>

        <!--消息记录查询-->
        <el-dialog
            :visible.sync="msgDialog"
            :append-to-body='true'
            title="以发送消息内容"
            class="msg-dialog bill-dialog">
                <div class="editor template-item" v-if="selectTemplate">
                    <div class="content" v-html="selectTemplate.data">
                        {{selectTemplate.data}}
                    </div>
                </div>
        </el-dialog>

        <!--通知对话框-->
        <el-dialog
        :visible.sync="noticeDialog"
        :append-to-body='true'
        width="800px"
        class="bill-dialog">
            <div slot="title">
                <span>通知</span>
            </div>
            <notice />
        </el-dialog>
        

    </div>
</template>
<script>
// 导出excel组件
// import JsonExcel from 'vue-json-excel';
import JsonExcel from "@lib/JsonExcel.js";

import {getWxMessageRecord,getDatabaseUser} from "@api/billing"
import {getUserSetting} from "@api/map2d";

export default {
    name:"msgrecord",
    data(){
        return {
            tableHeight:600, // 表格高度

            msglist: [], // 充值记录
            msgpage:{
                current:1,
                size:10,
                total:0,
            }, // 用户分页信息

            // 站点分组级联选择内容
            sitesList:{},
            site_list:'', // 选中站点列表

            start_date:'', //开始日期
            end_date:'', // 结束日期
            start_time:'', // 开始时间
            end_time:'', // 结束时间
            time_range:"day", // 时间范围下拉框

            sites: null, // 站点数据，包括站点mediumList、siteLevel、groupList、siteList
            sitesDialog:false, // 站点筛选对话框

            msgFileName:"消息记录.xls", // 导出文件的名称
            msgHeader:"", // 导出表头
            msgFileds:{
                "消息类型":"templatetitle",
                "接收人":"tousername",
                '发送人':"fromusername",
                "状态码":"status",
                "发送时间":"create_time",
            },// 充值记录导出字段

            msgDialog:false, // 消息对话框
            currMsg:null, // 当前选中消息
            wxTemplates:null, // 模板列表
            selectTemplate:null, // 选择的模板

            userList:null, // 用户列表

            noticeDialog:false, // 通知对话框
        }
    },
    computed:{
        // 用户信息
        userinfo(){
            return this.$store.state.user;
        },
        // 站点数据
        sites_config(){
            return this.$store.getters.getSitesConfigByPage();
        },
    },
    components: {
        'downloadExcel':JsonExcel, // 数据导出
        notice: () => import('./NoticeDialog.vue'), // 通知
    },
    // components: { countTo },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        })
    },
    methods:{
        // 数据初始化
        init(){
            let $el=document.querySelector('.billing-wrap').parentNode;
            let offsetHeight=$el.offsetHeight;
            this.tableHeight=offsetHeight-250;
            // 清空引用
            $el=null;
            
            let nowTime=this.$moment();
            nowTime=nowTime.add(2, 'minutes');
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间

            // 格式化结束日期和时间
            let endTime=nowTime.subtract(1, 'days');
            this.start_date= endTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=endTime.format('HH:mm'); // 开始时间

            // 当前选择时间
            this.time_range="day";

            // 获取数据
            this.getDataList()
            // 获取模板
            this.getTemplates();

            // 获取用户信息
            this.getUserList();

        },
        // 获取用户充值记录
        getDataList(start_time,end_time,page,size){
            // 开始时间
            let start_date=this.$moment(this.start_date);
            start_date=start_date.format('yyyy-MM-DD');
            start_time=start_time||( start_date+ " "+this.start_time);
            // 结束时间
            let end_date=this.$moment(this.end_date);
            end_date=end_date.format("yyyy-MM-DD");
            end_time=end_time||(end_date+" "+this.end_time);

            // 站点列表
            page=page||this.msgpage.current;
            size=size||this.msgpage.size;

            getWxMessageRecord(start_time,end_time,page,size).then(res=>{
                if(res.status&&res.status==200){
                    let content=res.content;
                    this.msglist=content.records;
                    
                    // 保留分页信息
                    let page={
                        current:1,
                        size:10,
                        total:0,
                    };
                    page.current=content.current;
                    page.size=content.size;
                    page.total=content.total;
                    // 设置分页信息
                    this.msgpage=page;
                }
            })
        },
        // 获取模板列表
        getTemplates(){
            if(!this.wxTemplates){
                getUserSetting("wxtemplate").then(res=>{
                    if(res.status&&res.status==200){
                        let content=res.content;
                        let templates=content.templates;
                        this.wxTemplates=templates;
                    }
                })
            }

        },

        // 显示通知对话框
        showNoticeDialog(){
            this.noticeDialog=true;
        },


        // 每页条数改变
        handleSizeChange(val){
            this.getDataList("","",1,val);
        },
        // 页码改变
        handleCurrentChange(val){
            this.getDataList("","",val,this.msgpage.size);
        },


        // 时间范围事件
        timeRangeChange(val){
            // 获取当前时间
            let nowTime=this.$moment();
            let startTime=nowTime;

            // 格式化结束日期和时间
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间
            switch (val){
                case "day":
                startTime=nowTime.add(-1,'day');
                break;
                case "week":
                startTime=nowTime.add(-1,'week');
                break;
                case "month":
                startTime=nowTime.add(-1,'month');
                break;
                case "year":
                startTime=nowTime.add(-1,'year');
                break;
                default:
                startTime=nowTime.add(-1,'day');
                break;
            }
            this.start_date= startTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=startTime.format('HH:mm'); // 开始时间
        },

        // 时间改变
        timeChange(){
            this.time_range="customize"; // 改为自定义
        },

        // 查询数据
        searchData(){
            this.getDataList("","",1,this.msgpage.size);
        },

        // 查看
        handleLook(index,row){
            this.currMsg=row;
            let templateid=row.templateid;
            // 进行内容替换
            let template=this.wxTemplates[templateid];
            let postmsg=JSON.parse(row.postmsg);

            postmsg=postmsg.data;
            // 处理内容
            var content=template.content;
            var templatedata=content;
            var re = /{{(.*?).DATA}}/ig;    
            var r = "";   
            while((r = re.exec(content))) {   
                var a=r[0]; // 全部的字符串
                var b=r[1]; // 名称
                templatedata=templatedata.replace(a,'<span data-key="'+b+'" class="template-span '+b+'" style="color:'+postmsg[b].color+';">'+postmsg[b].value+'</span>');
            }
            template.data=templatedata;

            this.selectTemplate=template;
            // 打开对话框
            this.msgDialog=true;
        },

        // 导出文件之前，修改文件信息
        exportFile(){
            let start_date= this.$moment(this.start_date).format('yyyy-MM-DD'); // 开时日期
            let statTime=this.start_time;

            let end_date= this.$moment(this.end_date).format('yyyy-MM-DD'); // 结束日期
            let endTime=this.end_time;
            
            let fileName="消息记录";
            this.msgFileName=fileName+".xls";
            this.msgHeader="消息记录 开始时间："+start_date+" "+statTime+" 结束时间："+end_date+" "+endTime;

        },

        // 获取用户列表
        getUserList(){
            getDatabaseUser().then(res=>{
                if(res.status&&res.status==200){
                    let users=res.content;
  
                    let userList={};
                    // 数据处理,保存用户列表信息
                    for(let user of users){
                        userList[user.WxOpenid]={
                            "WxOpenid":user.WxOpenid,
                            "UserRealName":user.UserRealName,
                            "UserCompanyBranch":user.UserCompanyBranch,
                            "UserJob":user.UserJob,
                            "UserPhone":user.UserPhone,
                            UserCompany:user.UserCompany,
                        }
                    }
                    // 触发更新
                    this.userList=userList;
                }
            });
        },
    }
}
</script>

<style lang="scss">
.msg-wrap{
    .el-divider__text{
        background-color: #f5f8ff;
    }
    .record{
         // 单元格内容居中
        .record-table{
            table td,table th{
                text-align: center !important;
            }
            .RecordTime .cell{
                word-break:initial;
                white-space: pre;
            }
        }
    }
    .pagination{
        float:right;
    }


    /**菜单栏 */
    .menu-wrap{
        background: #fff;
        padding:10px;

        /**菜单栏按钮 */
        .menu-btn {
            height: 40px;
            margin-right: 5px;
            padding: 12px;
            margin-left: 5px;

            span {
                font-size: 16px;
                font-weight: 400;
                cursor: pointer;
            }
        }

        .date-input{
            width:135px;
            input {
                width:130px;
                padding-right: 15px;
            }
        }
        .time-input{
            width:100px;
            input {
                width:90px;
                padding-right: 10px;
            }
        }
        /**时间范围 */
        .time_range{
            width:120px;
        }
        /**最大行数 */
        .maxrowcount{
            input{
                width: 100px;
                padding:0 0 0 5px;
            }

        }

        .el-form-item{
            margin-bottom: initial;
        }

        .export-excel-wrapper{
            display: inline-block;
        }

        .el-radio-button__inner{
            padding:12px;
        }
    }
}


/** 模板消息 */
.msg-dialog{
    .el-dialog__body{
        text-align: center;
        padding: 0 15px 50px 15px !important;
        width: 300px!important;
        min-width: 400px!important;
    }

    .template-item{
        text-align: left;
        width:250px;
        display: inline-block;
        font-size: 16px;

        .title{
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 5px;
        }

        .content{
            min-height: 100px;
            border:1px solid #aaa;
            white-space: pre-line;
            word-break: break-all;
            padding: 10px;
            border-radius: 5px;
        }
        .detail{
            border:1px solid #aaa;
            border-top:none;
            padding:10px;
            cursor: pointer;
            min-height: 40px;

            .el-icon-arrow-right{
                float: right;
                vertical-align: middle;
            }
        }
    }
}

</style>